import Card from "components/Card/Card";
import Select from "components/inputs/Select/Select";
import { useCallback, useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import {
  useGetFileByIdQuery,
  usePatchFileByIdMutation,
} from "services/file-api.ts";
import { useSelector } from "utils/redux";

const EditFileOwner = ({
  isReadOnly = false,
}: { isReadOnly?: boolean } = {}) => {
  const { fileId } = useParams<{ fileId: string }>();
  const constants = useSelector((state) => state.shared.constants);
  const [patchFileById] = usePatchFileByIdMutation();
  const [error, setError] = useState<string | null>(null);

  const {
    control,
    reset,
    getValues,
    formState: { errors },
  } = useForm();

  const { data: fileData } = useGetFileByIdQuery(
    { id: fileId },
    { skip: !fileId },
  );

  useEffect(() => {
    if (fileData) {
      reset({
        owner: fileData?.owner || "",
      });
    }
  }, [fileData, reset]);

  const handleSave = useCallback(
    async (api: "file", field: string, value: number) => {
      try {
        await patchFileById({
          id: fileId,
          data: {
            [field]: value,
          },
        }).unwrap();
        setError(null);
      } catch (err) {
        const errorMessage =
          err?.data?.detail || "An unexpected error occurred";
        setError(errorMessage);
        reset();
      }
    },
    [patchFileById, fileId],
  );

  return (
    <Card heading="File Owner">
      <Controller
        name="owner"
        control={control}
        render={({ field: { name, onChange, value } }) => (
          <Select
            name={name}
            label="Owner"
            options={constants?.OPERATIONS_USERS}
            errors={errors}
            isClearable={false}
            readOnly={isReadOnly}
            value={constants?.OPERATIONS_USERS.find(
              (option) => option.value === value,
            )}
            onChange={onChange}
            onBlur={() => {
              if (!isReadOnly) {
                const option = getValues(name);
                handleSave("file", name, option.value);
              }
            }}
          />
        )}
      />
      <p className="error-message">{error}</p>
    </Card>
  );
};

export default EditFileOwner;
